<template>
  <Content
    class="col-span-full"
    :title="$route.name"
    :showAdd="false"
    v-loading="loading"
    :router="{
      name: 'GEOFENCE_LIST',
    }"
  >
    <Notice v-if="!disabled" class="col-span-full mb-6 border-0">
      {{ $t('AreaInstructions') }}
    </Notice>

    <div class="col-span-full mb-4" id="mapid" ref="mapElement"></div>

    <customDialog
      v-if="showMap"
      :title="$t('SETTING')"
      childClass="info_msg add_geo"
      :show="showMap"
      :showCancel="true"
      customWidth="60%"
      :showClose="true"
      @show="showMap = $event"
      @close="clickOutsideOfDialog()"
      @confirmButn="submitGeofence('ruleForm')"
    >
      <el-form
        status-icon
        :model="ruleForm"
        label-position="top"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm grid grid-cols-1 gap-4 status-icon"
      >
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 pt-2 relative">
          <el-form-item
            :label="$t('AREA_TITLE')"
            prop="title"
            :rules="{
              required: true,
              message: $t('REQUIRED_FIELD', {
                type: $t('AREA_TITLE'),
              }),
              trigger: 'blur',
            }"
          >
            <el-input
              :disabled="disabled"
              type="text"
              v-model="ruleForm.title"
              autocomplete="off"
            ></el-input>
          </el-form-item>

          <el-form-item
            class="flex items-center justify-center"
            prop="is_forbidden"
          >
            <el-switch
              v-model="ruleForm.is_forbidden"
              active-color="#ff4949"
              inactive-color="#13ce66"
              :active-text="$t('FORBIDDEN')"
              :inactive-text="$t('FREE')"
            ></el-switch>
          </el-form-item>

          <div class="col-span-full grid grid-cols-1 lg:grid-cols-2 gap-4">
            <el-form-item
              :label="$t('AREA_COLOR')"
              prop="color.id"
              v-loading="colorLoading"
              element-loading-spinner="el-icon-loading"
              :rules="{
                required: true,
                message: $t('REQUIRED_FIELD', {
                  type: $t('AREA_COLOR'),
                }),
                trigger: 'blur',
              }"
            >
              <el-select
                :disabled="disabled"
                :placeholder="$t('SELECT_PLACEHOLDER')"
                v-model="ruleForm.color.id"
                clearable
                filterable
              >
                <template slot="prefix">
                  <span
                    class="prefix w-2 h-2 rounded-full border border-gray-200"
                    :style="`background-color: ${prefixGenerateColor}`"
                  ></span>
                </template>
                <el-option
                  v-for="item in colorList"
                  :key="item.id"
                  :label="$i18n.locale == 'fa' ? item.fa_title : item.en_title"
                  :value="item.id"
                >
                  <div class="flex items-center">
                    <span
                      :style="`background-color:${item.code}`"
                      class="mx-2 w-2 h-2 rounded-full border border-gray-200"
                    ></span>
                    <span>
                      {{ $i18n.locale == 'fa' ? item.fa_title : item.en_title }}
                    </span>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>

            <VehicleSelect
              :loading="vehicleLoading"
              prop="company_vehicle.id"
              :model="ruleForm.company_vehicle.id"
              @update="ruleForm.company_vehicle.id = $event"
              :multiple="true"
              :collapseTags="true"
              :disabled="disabled"
            />

            <el-form-item
              :label="$t('STATUS')"
              prop="is_active"
              :rules="{
                required: true,
                message: $t('REQUIRED_FIELD', {
                  type: $t('STATUS'),
                }),
                trigger: 'blur',
              }"
            >
              <el-select
                :disabled="disabled"
                filterable
                v-model="ruleForm.is_active"
                :placeholder="$t('SELECT_PLACEHOLDER')"
              >
                <el-option
                  v-for="item in statusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              :label="$t('MAX_SPEED')"
              prop="max_speed"
              :rules="{
                required: true,
                message: $t('REQUIRED_FIELD', {
                  type: $t('MAX_SPEED'),
                }),
                trigger: 'blur',
              }"
            >
              <el-input-number
                :disabled="disabled"
                v-model="ruleForm.max_speed"
                :step="10"
              ></el-input-number>
            </el-form-item>

            <el-form-item
              :label="$t('START_TIME')"
              prop="start_time"
              :rules="{
                required: false,
                message: $t('REQUIRED_FIELD', {
                  type: $t('START_TIME'),
                }),
                trigger: 'blur',
              }"
            >
              <el-time-picker
                disabled
                format="HH:mm"
                value-format="HH:mm"
                v-model="ruleForm.start_time"
              ></el-time-picker>
            </el-form-item>
            <el-form-item
              :label="$t('END_TIME')"
              prop="end_time"
              :rules="{
                required: false,
                message: $t('REQUIRED_FIELD', {
                  type: $t('END_TIME'),
                }),
                trigger: 'blur',
              }"
            >
              <el-time-picker
                disabled
                format="HH:mm"
                value-format="HH:mm"
                v-model="ruleForm.end_time"
              ></el-time-picker>
            </el-form-item>
          </div>
          <el-form-item
            class="col-span-full"
            :label="$t('description')"
            prop="description"
          >
            <el-input
              :disabled="disabled"
              type="textarea"
              v-model="ruleForm.description"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
    </customDialog>

    <div class="flex justify-end col-span-full mt-4 mb-0" v-if="!formType">
      <el-button type="success" @click.prevent="mySubmit">
        {{ $t('SUBMIT') }}
      </el-button>
    </div>
  </Content>
</template>
<script>
import { colorList, licenseChars } from '@/api/global'
import { fenceShape, editFence, getFence } from '@/api/fence'
import VehicleSelect from '@/components/elements/vehiclesSelect.vue'
import config from '@/configs/configs.js'
import { resetForm } from '@/mixins/resetForm'
import customDialog from '@/components/elements/dialog'
import { searchAddress } from '@/mixins/searchAddress'
import Notice from '@/components/elements/notice'
import { carsListSummary } from '@/api/cars'
import { convertToUTC } from '@/mixins/convertToUTC'
import { convertTimeToLocal } from '@/mixins/convertTimeToLocal'

export default {
  props: ['formType'],
  components: {
    customDialog,
    Notice,

    VehicleSelect,
  },
  computed: {
    prefixGenerateColor() {
      return this.colorList.find((i) => i.id == this.ruleForm.color.id) !=
        undefined
        ? this.colorList.find((i) => i.id == this.ruleForm.color.id).code
        : ''
    },
  },
  mixins: [searchAddress, resetForm, convertToUTC, convertTimeToLocal],
  data() {
    return {
      defaultLocation: [35.71343059526645, 51.407055307645365],
      map: null,
      alphaList: [
        {
          code: '',
          char: '',
          id: '',
        },
      ],
      showMap: false,
      loading: true,
      fenceShapes: null,

      vehciles: [],
      vehicleLoading: true,
      speedDialog: false,
      timeDialog: false,

      colorList: [],
      disabled: this.formType,
      colorLoading: true,
      currentLayer: null,
      activeName: 'BASIC_INFO',
      statusList: [
        {
          value: true,
          label: this.$i18n.t('ACTIVE'),
        },
        {
          value: false,
          label: this.$i18n.t('INACTIVE'),
        },
      ],
      ruleForm: {
        company_vehicle: {
          id: '',
        },
        color: {
          id: 1,
        },
        is_active: true,
        is_forbidden: false,
        title: '',
        description: '',
        max_speed: 80,
        start_time: null,
        end_time: null,
        description: '',
      },

      fence: [],
      modalType: '',
      isFenceCreated: false,
    }
  },
  methods: {
    mySubmit() {
      if (this.fence.length == 0) {
        this.$notify.error({
          title: this.$i18n.t('REQUIRED_FIELD', {
            type: this.$i18n.t('GEOFENCE'),
          }),
          duration: 5000,
          customClass: 'error_msg',
        })
        return false
      }

      var result = this.fence.map((data) => ({
        max_speed: data.max_speed,
        title: data.title,
        features: data.features,
        is_active: data.is_active,
        is_forbidden: data.is_forbidden,
        description: data.description,
        company_vehicles:
          data.company_vehicle == ''
            ? []
            : typeof data.company_vehicle === 'object' &&
              data.company_vehicle !== null &&
              'id' in data.company_vehicle
            ? data.company_vehicle.id
            : data.company_vehicle,
        color:
          typeof data.color === 'object' &&
          data.color !== null &&
          'id' in data.color
            ? data.color.id
            : data.color,
        shape: data.shape,
        id: this.$route.params.id,
      }))
      const actionPayload = result[0]

      editFence.api(actionPayload).then((res) => {
        if (res) {
          this.$notify.success({
            title:
              this.$t(this.$route.name) + ' ' + this.$t('SUCCESSFULLY_DONE'),
            duration: 5000,
            customClass: 'succ_msg',
          })
          this.$router.push({
            name: 'GEOFENCE_LIST',
          })
        }
      })
    },

    clickOutsideOfDialog() {
      if (this.currentLayer) {
        this.resetPopupForm('ruleForm')

        if (this.modalType === 'add' && !this.formType) {
          this.map.removeLayer(this.currentLayer)
          this.removeOldLayer(this.currentLayer)
          this.isFenceCreated = false
        }
        this.currentLayer = null
      }
      this.showMap = false
    },
    searchColor(color) {
      return this.colorList.find((i) => i.id == color) != undefined
        ? this.colorList.find((i) => i.id == color).code
        : ''
    },

    submitGeofence(formName) {
      if (this.fence.length > 1) {
        this.showMap = false
        this.resetPopupForm(formName)
        this.currentLayer = null
        this.$notify.warning({
          title: 'اخطار',
          message:
            'در هر ثبت ناحیه جغرافیایی، مجاز به اضافه کردن یک ناحیه هستید',
          duration: 5000,
          customClass: 'warning_msg',
        })

        // Remove the last added layer
        const lastAddedLayer = this.fence.pop()
        if (lastAddedLayer && lastAddedLayer.myLayer) {
          this.map.removeLayer(lastAddedLayer.myLayer)
        }
      } else {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.fenceGenreate(this.ruleForm)
            this.changeLayerColor(
              this.currentLayer,
              this.prefixGenerateColor,
              !this.ruleForm.is_active ? '.5' : '.8',
              this.ruleForm.title
            )

            this.showMap = false
            this.resetPopupForm(formName)
            this.currentLayer = null
          }
        })
      }
    },
    resetPopupForm(formName) {
      this.resetForm(formName)
      this.ruleForm.color.id = 1

      this.ruleForm.company_vehicle.id = ''
    },
    fenceGenreate(data, type = 'add') {
      let currenctFence = this.fence.find(
        (data) => data.id == this.currentLayer.id
      )

      if (type == 'add') {
        currenctFence.title = data.title
        currenctFence.description = data.description
        currenctFence.color = data.color.id
        currenctFence.company_vehicle = data.company_vehicle.id
        currenctFence.is_active = data.is_active
        currenctFence.is_forbidden = data.is_forbidden
        currenctFence.max_speed = data.max_speed
        currenctFence.start_time = data.start_time
        currenctFence.end_time = data.end_time
      } else if (type == 'edit') {
        data.title = currenctFence.title
        data.description = currenctFence.description
        data.color.id = currenctFence.color.id || currenctFence.color
        data.company_vehicle.id = currenctFence.company_vehicle.id
        data.is_active = currenctFence.is_active
        data.is_forbidden = currenctFence.is_forbidden
        data.max_speed = currenctFence.max_speed
        data.start_time = currenctFence.start_time
        data.end_time = currenctFence.end_time
      }
    },

    addNonGroupLayers(sourceLayer, targetGroup) {
      if (sourceLayer instanceof L.LayerGroup) {
        sourceLayer.eachLayer(function (layer) {
          this.addNonGroupLayers(layer, targetGroup)
        })
      } else {
        targetGroup.addLayer(sourceLayer)
      }
    },

    loadMap() {
      var map = L.map(this.$refs['mapElement'], {
        tap: false,
      }).setView(this.defaultLocation, 10)
      L.tileLayer(config.tile, {
        attribution: '@ Carpo',
        id: 'mapbox/streets-v11',
        tileSize: 512,
        zoomOffset: -1,
        accessToken: config.leaflet,
      }).addTo(map)
      this.map = map

      const provider = new window.GeoSearch.OpenStreetMapProvider()
      const search = new GeoSearch.GeoSearchControl({
        provider: provider,
        style: 'bar',
        updateMap: true,
        autoClose: true,
      })
      map.addControl(search)
      var fg = L.featureGroup()

      map.pm.setLang('fa')

      var randomNum = 1000

      map.on('pm:create', (e) => {
        if (this.isFenceCreated) {
          // If a fence has already been created, prevent adding another
          this.$notify.warning({
            title: 'اخطار',
            message:
              'در هر ثبت ناحیه جغرافیایی، مجاز به اضافه کردن یک ناحیه هستید',
            duration: 5000,
            customClass: 'warning_msg',
          })
          map.removeLayer(e.layer) // Remove the newly created layer
          return
        }

        let myLayer = e.layer
        randomNum++

        let shape = e.shape.toLowerCase()

        fg.addLayer(myLayer)
        this.showMap = true
        let geoJson = e.layer.toGeoJSON()

        this.fence.push({
          myLayer: myLayer,
          id: randomNum,
          features:
            shape != 'circle'
              ? [geoJson.geometry.coordinates[0]]
              : {
                  radius: e.layer.getRadius(),
                  coordinates: geoJson.geometry.coordinates,
                },
          shape: this.shapeDic(shape),
        })
        myLayer.id = randomNum
        this.currentLayer = myLayer
        this.currentLayer.id = randomNum
        this.modalType = 'add'

        myLayer.on('dblclick', (e) => {
          this.showMap = true
          this.currentLayer = myLayer
          this.currentLayer.id = myLayer.id
          this.fenceGenreate(this.ruleForm, 'edit')
          this.modalType = 'edit'
        })

        myLayer.on('pm:remove', (e) => {
          this.removeOldLayer(myLayer)

          this.isFenceCreated = false
        })

        this.isFenceCreated = true
      })
      map.doubleClickZoom.disable()

      map.pm.addControls({
        position: 'topleft',
        drawPolyline: false,
        drawCircleMarker: false,
        drawMarker: false,
        drawCircle: true,
        drawRectangle: false,
        drawText: false,
        cutPolygon: false,
        rotateMode: false,
        dragMode: true,
        editMode: true,
      })
      if (this.formType) {
        map.pm.removeControls()
      }
    },
    changeLayerColor(layer, color, opacity = 0.8, title = '') {
      layer.getElement().setAttribute('fill', color)
      layer.getElement().setAttribute('stroke', color)
      layer.getElement().setAttribute('opacity', opacity)
      layer.getElement().setAttribute('fill-opacity', opacity)
      // let newTitle = document.createElement("text");
      // newTitle.innerHTML = title;
      // layer.getElement().parentElement.appendChild(newTitle);
    },
    transformLayerToJson(layer) {
      const json = layer.toGeoJSON()

      if (layer instanceof L.Circle) {
        json.properties.radius = layer.getRadius()
      }

      return json
    },
    onEachFeature(feature, layer) {
      let properties_ = feature.properties
      let geometry_ = feature.geometry

      layer.setStyle({
        color: this.searchColor(properties_.color.id),
        fillColor: this.searchColor(properties_.color.id),
        fillOpacity: properties_.is_active ? '.8' : '.5',
      })

      this.fence.push({
        myLayer: layer,
        id: properties_.id,
        color: properties_.color,
        company_vehicle: {
          id: properties_.company_vehicle,
        },
        description: properties_.description,
        is_active: properties_.is_active,
        is_forbidden: properties_.is_forbidden,
        shape: properties_.shape,
        max_speed: properties_.max_speed,
        start_time: properties_.start_time,
        end_time: properties_.end_time,
        title: properties_.title,
        features:
          this.shapeId(properties_.shape).en_title.toLowerCase() != 'circle'
            ? geometry_.coordinates
            : {
                radius: properties_.radius,
                coordinates: geometry_.coordinates,
              },
        shape: properties_.shape,
      })

      layer.on('dblclick', (e) => {
        this.showMap = true
        this.currentLayer = layer

        this.currentLayer.id = properties_.id
        this.fenceGenreate(this.ruleForm, 'edit')
      })
      let randomNum = 1000
      layer.on('pm:edit', (e) => {
        let newLayer = e.layer
        this.currentLayer = newLayer
        this.currentLayer.id = layer.id

        let currenctFence = this.fence.find(
          (data) => data.id == layer.feature.properties.id
        )

        currenctFence.features =
          e.shape.toLowerCase() != 'circle'
            ? [newLayer.toGeoJSON().geometry.coordinates[0]]
            : {
                radius: e.layer.getRadius(),
                coordinates: newLayer.toGeoJSON().geometry.coordinates,
              }
      })

      layer.on('pm:remove', (e) => {
        this.removeOldLayer(properties_)

        this.isFenceCreated = false
      })
    },
    createLayersFromJson(data) {
      data.forEach((geo, id) => {
        L.geoJSON(geo, {
          pointToLayer: (feature, latlng) => {
            if (feature.properties.radius) {
              return new L.Circle(latlng, feature.properties.radius)
            } else {
              return new L.Marker(latlng)
            }
          },
          onEachFeature: this.onEachFeature,
        }).addTo(this.map)
      })
    },
    shapeDic(myShape) {
      return this.fenceShapes.find(
        (shape) => shape.en_title.toLowerCase() == myShape.toLowerCase()
      ).id
    },
    shapeId(myShape) {
      return this.fenceShapes.find((shape) => shape.id == myShape)
    },
    removeOldLayer(layer) {
      this.fence = this.fence.filter((data) => data.id !== layer.id)
    },
  },
  mounted() {
    this.searchAddress().then((res) => {
      if (res) {
        this.loadMap()
      }
    })
  },
  created() {
    colorList.api().then((res) => {
      if (res) {
        this.colorList = res
        this.colorLoading = false
      }
    })
    licenseChars.api().then((res) => {
      this.alphaList = res
    })
    carsListSummary.api().then((res) => {
      if (res) {
        this.vehciles = res
        this.vehicleLoading = false
      }
    })
    fenceShape.api().then((res) => {
      if (res) {
        this.fenceShapes = res
        this.loading = false
        getFence.api(this.$route.params.id).then((res) => {
          if (res) {
            this.defaultLocation =
              res.features.coordinates != undefined
                ? [res.features.coordinates[1], res.features.coordinates[0]]
                : [res.features[0][0][1], res.features[0][0][0]]

            this.map.setView(this.defaultLocation)

            var test = [
              {
                type: 'Feature',
                properties: {
                  color: res.color,
                  company_vehicle: res.company_vehicles.map((i) => i.id),
                  description: res.description,
                  id: res.id,
                  is_active: res.is_active,
                  is_forbidden: res.is_forbidden,
                  shape: res.shape,
                  max_speed: res.max_speed,
                  start_time: this.convertTimeToLocal(res.start_time),
                  end_time: this.convertTimeToLocal(res.end_time),
                  title: res.title,
                  radius: res.features.radius,
                },
                geometry: {
                  type:
                    this.shapeId(res.shape).en_title.toLowerCase() == 'circle'
                      ? 'Point'
                      : 'Polygon',
                  coordinates:
                    res.features.coordinates != undefined
                      ? res.features.coordinates
                      : res.features,
                },
              },
            ]

            const parseData = JSON.parse(JSON.stringify(test))
            this.createLayersFromJson(parseData)
          }
        })
      }
    })
  },
}
</script>
